__turbopack_context__.v({
  "brand": "siteChrome-module__nmu6Ya__brand",
  "brandMark": "siteChrome-module__nmu6Ya__brandMark",
  "brandName": "siteChrome-module__nmu6Ya__brandName",
  "brandSub": "siteChrome-module__nmu6Ya__brandSub",
  "footer": "siteChrome-module__nmu6Ya__footer",
  "footerBottom": "siteChrome-module__nmu6Ya__footerBottom",
  "footerCopyright": "siteChrome-module__nmu6Ya__footerCopyright",
  "footerCredit": "siteChrome-module__nmu6Ya__footerCredit",
  "footerCreditLink": "siteChrome-module__nmu6Ya__footerCreditLink",
  "footerLinks": "siteChrome-module__nmu6Ya__footerLinks",
  "menuToggle": "siteChrome-module__nmu6Ya__menuToggle",
  "mobileNav": "siteChrome-module__nmu6Ya__mobileNav",
  "mobileNavCta": "siteChrome-module__nmu6Ya__mobileNavCta",
  "mobileNavItem": "siteChrome-module__nmu6Ya__mobileNavItem",
  "mobileOverlay": "siteChrome-module__nmu6Ya__mobileOverlay",
  "mobileOverlayClose": "siteChrome-module__nmu6Ya__mobileOverlayClose",
  "nav": "siteChrome-module__nmu6Ya__nav",
  "navCta": "siteChrome-module__nmu6Ya__navCta",
  "srOnly": "siteChrome-module__nmu6Ya__srOnly",
  "topbar": "siteChrome-module__nmu6Ya__topbar",
});
